import { LayoutDefault } from "@/components/layouts/LayoutDefault";
import { ReferralLanding } from "@/pages";
import { createFileRoute, redirect } from "@tanstack/react-router";
import * as z from "zod";

const referralSchema = z.object({
  referral_code: z.optional(z.string()),
});

export type ReferralSearchSchema = z.infer<typeof referralSchema>;

const Page = () => (
  <LayoutDefault>
    <ReferralLanding />
  </LayoutDefault>
);

export const Route = createFileRoute("/r/$referralCode")({
  component: Page,
  validateSearch: referralSchema,
  beforeLoad: async ({ location, params }) => {
    document.title = "Maifud - Código de referido";
    if (params.referralCode) {
      return;
    }
    const referral_code = Object.keys(location.search)[0];
    throw redirect({
      to: "/li",
      search: {
        referral_code,
      },
    });
  },
});
